import React from 'react';
import { Grid } from 'semantic-ui-react';
import { setRowSize } from 'utils';

import GridColumnInputWrapper from '../../../common/GridColumnInputWrapper';
import {
  FileInputWrapper,
  TableFileViewerWrapper,
  AccordionWrapper,
  InputWrapper,
} from 'react-lib/dist/components-es';
import Connector from '../../../../agent';

type Props = {
  values: any;
  isHistory: boolean;
  errors: any;
  setFieldValue: (arg1: string, arg2: string) => void;
  disabled: boolean;
};

const IOtherContainer = ({ values, isHistory, errors, setFieldValue, disabled }: Props) => {
  const { api } = Connector;

  const getFileWrapper = () => {
    return (
      <GridColumnInputWrapper
        label="inventory.details.page.other.container.files.input"
        name="files"
        fileDataProp="fileData"
        value={values.files}
        displayOnlyFirstLevelErrors={true}
        values={values}
        setFieldValue={setFieldValue}
        disabled={disabled}
        errors={errors}
        render={(props: any) => (
          <FileInputWrapper
            {...props}
            errors={errors}
            multiple={true}
            errorPaths={['.format', 'size']}
            hideFile={(f: any) =>
              (f[props.fileDataProp].deleted || f[props.fileDataProp].delUser) && !isHistory
            }
            fileViewerRender={(props: any) => <TableFileViewerWrapper api={api} {...props} />}
          />
        )}
      />
    );
  };

  const getOtherContainerContent = () => {
    const inputText = values.remarks || '';
    const rows = setRowSize(inputText, 2, 40);
    return (
      <Grid doubling columns={2} verticalAlign="top" stretched>
        <GridColumnInputWrapper
          value={inputText}
          name="remarks"
          label="inventory.details.page.other.container.remarks.input"
          rows={rows}
          values={values}
          setFieldValue={setFieldValue}
          disabled={disabled}
          errors={errors}
          render={(props: any) => <InputWrapper {...props} type="textarea" size={'massive'} />}
        />
        {getFileWrapper()}
      </Grid>
    );
  };
  return (
    <AccordionWrapper
      collapsed={false}
      accordionTitle="inventory.details.page.other.container.title"
      render={getOtherContainerContent}
      className=""
    />
  );
};

export default IOtherContainer;
